<template>
  <div class="not-found d-flex center">
    <el-empty
    :image-size="300"
    description=" "
    >
      <p class="tip">该页面无法访问或不存在</p>
    </el-empty>
  </div>
</template>

<script>
export default {

}
</script>

<style lang="scss" scoped>
  .not-found {
    width: 100%;
    height: 100vh;
    .tip {
      font-weight: bold;
      font-size: 24px;
      color: #939090;
    }
  }
</style>